import { ETrackLabelActionTypes } from '../../actions/trackLabel';
import { TLabel } from '../../types/auth';
import { TReduxActions } from '../../types/redux';

const defaultState: TLabel = 'main_login_block';

export function trackLabelReducer(state: TLabel = defaultState, action: TReduxActions) {
  switch (action.type) {
    case ETrackLabelActionTypes.SetTrackLabel:
      return action.payload;
    default:
      return state;
  }
}
